// src/App.jsx
import React from "react";
import "./App.css";
import Sidebar from "./components/Sidebar";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import ListadoArticulosVenta from "./pages/articulos-venta";
import ListadoArticulosCompra from "./pages/articulos-compra";
import ListadoClientes from "./pages/clientes";
import ListadoProveedores from "./pages/proveedores";
import ListadoTodos from "./pages/todos";
import Cotizacion from "./pages/cotizacion";
import NuevaOrden from "./pages/orden";
import CalendarioGd from "./pages/calendario";
import Tareas from "./pages/tareas";
import Remisiones from "./pages/remisiones";
import Configuracion from "./components/Configuracion";
import Categorias from "./pages/categorias";
import Generador from "./pages/generador";
import Requisiciones from "./pages/requisiciones";
import Grupos from "./pages/grupos";
import ProductosRelacionados from "./components/ProductosRelacionados";
import GrupoProductos from "./components/GrupoProductos";
import NuevoPedido from "./pages/pedidos";
import Login from "./components/Login";
import Register from "./components/Register";
import PrivateRoute from "./components/PrivateRoute";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Dashboard from "./pages/inicio";
import Spinner from "./components/Spinner";
import { UsuariosProvider } from "./context/UsuariosContext";
import { NavProvider } from "./context/NavContext";
import { TaskProvider } from "./context/TaskContext";
import FacturasProveedores from "./pages/facturas-de-proveedores";
import FacturasClientes from "./pages/facturas-de-clientes";
import Calculador from "./pages/calculador";
import ScrollToTop from "./components/ScrollToTop";
import RegistroExitoso from "./components/RegistroExitoso";
import CartaEnvio from "./components/CartaEnvio";
import CartaIngresos from "./components/CartaIngresos";
import CartaNueva from "./components/CartaNueva";
import CartaPoder from "./components/CartaPoder";
import Terminos from "./pages/Terminos";
import Sucursales from "./components/Sucursales";

function AppContent() {
  const { loading } = useAuth();
  const location = useLocation();

  // 1) Mientras carga autenticación / perfil
  if (loading) {
    return <Spinner />;
  }

  // 2) Si es ruta pública, renderiza SOLO login/register/registro-exitoso
  const publicPaths = ["/login", "/registro", "/registro-exitoso"];
  if (publicPaths.includes(location.pathname)) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/registro" element={<Register />} />
        <Route path="/registro-exitoso" element={<RegistroExitoso />} />
        {/* Cualquier otro intento va a login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // 3) Rutas privadas: monta providers, sidebar y protege con PrivateRoute
  return (
    <UsuariosProvider>
      <NavProvider>
        <TaskProvider>
          <ScrollToTop />
          <div>
            <Routes>
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/orden"
                element={
                  <PrivateRoute>
                    <NuevaOrden />
                  </PrivateRoute>
                }
              />
              <Route
                path="/pedidos"
                element={
                  <PrivateRoute>
                    <NuevoPedido />
                  </PrivateRoute>
                }
              />
              <Route
                path="/cotizacion"
                element={
                  <PrivateRoute>
                    <Cotizacion />
                  </PrivateRoute>
                }
              />
              <Route
                path="/remisiones"
                element={
                  <PrivateRoute>
                    <Remisiones />
                  </PrivateRoute>
                }
              />
              <Route
                path="/proveedores"
                element={
                  <PrivateRoute>
                    <ListadoProveedores />
                  </PrivateRoute>
                }
              />
              <Route
                path="/clientes"
                element={
                  <PrivateRoute>
                    <ListadoClientes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/todos"
                element={
                  <PrivateRoute>
                    <ListadoTodos />
                  </PrivateRoute>
                }
              />
              <Route
                path="/categorias"
                element={
                  <PrivateRoute>
                    <Categorias />
                  </PrivateRoute>
                }
              />
              <Route
                path="/categorias/:categoriaNombre/productos"
                element={
                  <PrivateRoute>
                    <ProductosRelacionados />
                  </PrivateRoute>
                }
              />
              <Route
                path="/grupos"
                element={
                  <PrivateRoute>
                    <Grupos />
                  </PrivateRoute>
                }
              />
              <Route
                path="/grupos/:grupoNombre/productos"
                element={
                  <PrivateRoute>
                    <GrupoProductos />
                  </PrivateRoute>
                }
              />
              <Route
                path="/articulos-venta"
                element={
                  <PrivateRoute>
                    <ListadoArticulosVenta />
                  </PrivateRoute>
                }
              />
              <Route
                path="/articulos-compra"
                element={
                  <PrivateRoute>
                    <ListadoArticulosCompra />
                  </PrivateRoute>
                }
              />
              <Route
                path="/sucursales"
                element={
                  <PrivateRoute>
                    <Sucursales />
                  </PrivateRoute>
                }
              />
              <Route
                path="/calendario"
                element={
                  <PrivateRoute>
                    <CalendarioGd />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tareas"
                element={
                  <PrivateRoute>
                    <Tareas />
                  </PrivateRoute>
                }
              />
              <Route
                path="/configuracion"
                element={
                  <PrivateRoute>
                    <Configuracion />
                  </PrivateRoute>
                }
              />

              {/* Compatibilidad con enlaces viejos */}
              <Route
                path="/usuarios"
                element={<Navigate to="/configuracion?tab=usuarios" replace />}
              />
              <Route
                path="/personalizacion"
                element={
                  <Navigate to="/configuracion?tab=personalizacion" replace />
                }
              />
              <Route
                path="/facturas-de-proveedores"
                element={
                  <PrivateRoute>
                    <FacturasProveedores />
                  </PrivateRoute>
                }
              />
              <Route
                path="/facturas-de-clientes"
                element={
                  <PrivateRoute>
                    <FacturasClientes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/calculador"
                element={
                  <PrivateRoute>
                    <Calculador />
                  </PrivateRoute>
                }
              />
              <Route
                path="/generador"
                element={
                  <PrivateRoute>
                    <Generador />
                  </PrivateRoute>
                }
              />
              <Route
                path="/requisiciones"
                element={
                  <PrivateRoute>
                    <Requisiciones />
                  </PrivateRoute>
                }
              />
              <Route
                path="/carta-envio"
                element={
                  <PrivateRoute>
                    <CartaEnvio />
                  </PrivateRoute>
                }
              />
              <Route
                path="/carta-ingresos"
                element={
                  <PrivateRoute>
                    <CartaIngresos />
                  </PrivateRoute>
                }
              />
              <Route
                path="/carta-nueva"
                element={
                  <PrivateRoute>
                    <CartaNueva />
                  </PrivateRoute>
                }
              />
              <Route
                path="/carta-poder"
                element={
                  <PrivateRoute>
                    <CartaPoder />
                  </PrivateRoute>
                }
              />
              <Route
                path="/terminos-y-condiciones"
                element={
                  <PrivateRoute>
                    <Terminos />
                  </PrivateRoute>
                }
              />
            </Routes>

            <Sidebar />
          </div>
        </TaskProvider>
      </NavProvider>
    </UsuariosProvider>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </div>
  );
}
